import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import middleware_45global from "/opt/buildhome/repo/middleware/middleware.global.ts";
import page_45transition_45global from "/opt/buildhome/repo/middleware/page-transition.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  middleware_45global,
  page_45transition_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/opt/buildhome/repo/middleware/admin.ts"),
  rbac: () => import("/opt/buildhome/repo/middleware/rbac.ts")
}